var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('div',{staticClass:"h-8 w-full bg-white"}),_c('div',{staticClass:"p-3"},[_c('BookingDirection')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }